import { useContext } from "react";
import { getDataFromStorage } from "../util";
import useAxiosPrivate from "./useAxiosPrivate";
import AlertContext from "../context/AlertContext";
import useS3FileManagement from "./useS3FileManagement";

const useSubmitAssignment = () => {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();

  const {
    onMultiPartUpload,
    onUploadS3Object,
    getS3ObjectsByFolder,
    getFileDataByfolder,
    deleteS3Objects,
  } = useS3FileManagement();

  const convertIntoSandpackFiles = (files) => {
    return files.reduce((acc, cur) => {
      acc[`/${cur.filename}`] = {
        code: cur.fileContents,
      };
      return acc;
    }, {});
  };

  const validateImageExtension = (file) => {
    let allowedExtensions = ["jpg", "jpeg", "png", "gif"];
    let extension = file.name.split(".").pop().toLowerCase();

    return allowedExtensions.indexOf(extension) !== -1;
  };

  const submitAssignment = async (submissionData, isCloseAssignment) => {
    return new Promise((resolve, reject) => {
      return (async () => {
        try {
          let url = "";
          let form = new FormData();

          Alert.setIsLoaded(true);

          if (isCloseAssignment) {
            form.append("isCloseAssignment", true);
          }

          form.append("lpid", submissionData.lpId);
          form.append("libid", submissionData.libId);

          let filePath,
            attachment,
            fileName = "";

          if (submissionData.template) {
            fileName = submissionData.file.contentType;

            attachment =
              process.env.REACT_APP_DEPLOYMENT === "AWS"
                ? submissionData.file.file
                : JSON.stringify(submissionData.file.file);

            form.append("contenttype", fileName);
            form.append("template", submissionData.template);
            form.append("fileName", submissionData.file.name);

            filePath =
              "library/submission/" +
              getDataFromStorage("learnerid") +
              "/" +
              submissionData.file.name;
          } else if (submissionData.hasOwnProperty("file")) {
            attachment = submissionData.file;
            fileName = submissionData.file.name.replace(/^.*\./, "");

            form.append("contenttype", fileName);
            form.append("fileName", submissionData.file.name);

            filePath = `library/submission/${getDataFromStorage("learnerid")}/${
              submissionData.libId
            }/${submissionData.file.name}`;
          }

          form.append("isSave", submissionData.isSave);
          form.append("lpconfigid", submissionData.lpConfigId);
          form.append("learnerNotes", submissionData.learnerNotes);
          form.append("uploadedlink", submissionData.uploadedlink);
          form.append(
            "learnerid",
            !Alert.isAdmin
              ? getDataFromStorage("learnerid")
              : Alert.showBreadCrumbsData.learnerId
          );

          if (process.env.REACT_APP_DEPLOYMENT === "AWS" && !Alert.isAdmin) {
            if (submissionData.template) {
              if (submissionData.template.value !== "React") {
                let fileData = await getFileDataByfolder(
                  `${process.env.REACT_APP_WEBSITE_HOST}/${
                    submissionData.libId
                  }/${getDataFromStorage("learnerid")}`,
                  "HOST"
                );
                const files = convertIntoSandpackFiles(fileData);
                if (Object.keys(files ?? {}).length)
                  await deleteS3Objects(
                    Object.keys(files).map(
                      (file) =>
                        `${process.env.REACT_APP_WEBSITE_HOST}/${
                          submissionData.libId
                        }/${getDataFromStorage("learnerid")}${file}`,
                      "HOST"
                    )
                  );

                for (let file in Alert.sandpackFiles) {
                  let extraParams = {};
                  let code = Alert.sandpackFiles[file]?.code;

                  if (validateImageExtension({ name: file })) {
                    extraParams.ContentEncoding = "base64";

                    let base64Data = code
                      .replace(/^data:application\/octet-stream;base64,/, "")
                      .replace(/^data:image\/jpeg;base64,/, "")
                      .replace(/^data:image\/jpg;base64,/, "")
                      .replace(/^data:image\/png;base64,/, "");

                    code = Uint8Array.from(atob(base64Data), (char) =>
                      char.charCodeAt(0)
                    );
                  }
                  await onUploadS3Object(
                    `${process.env.REACT_APP_WEBSITE_HOST}/${
                      submissionData.libId
                    }/${getDataFromStorage("learnerid")}${file}`,
                    new Blob([code], { type: file.split(".")[1] }),
                    file.split(".")[1],
                    "HOST",
                    "PUT"
                  );
                  // await uploadFileToS3(
                  //   code,
                  //   `${process.env.REACT_APP_WEBSITE_HOST}/${
                  //     submissionData.libId
                  //   }/${getDataFromStorage("learnerid")}${file}`,
                  //   file.split(".")[1],
                  //   "uploadAssignment",
                  //   extraParams
                  // );
                }
              } else
                await onUploadS3Object(
                  `${process.env.REACT_APP_WEBSITE_HOST}/${
                    submissionData.libId
                  }/${getDataFromStorage("learnerid")}.json`,
                  JSON.stringify(Alert.sandpackFiles),
                  "json",
                  "HOST",
                  "PUT"
                );
              // await uploadFileToS3(
              //   JSON.stringify(Alert.sandpackFiles),
              //   `${process.env.REACT_APP_WEBSITE_HOST}/${
              //     submissionData.libId
              //   }/${getDataFromStorage("learnerid")}.json`,
              //   "json",
              //   "uploadAssignment"
              // );
            } else if (submissionData.hasOwnProperty("file")) {
              const result = await onMultiPartUpload(filePath, attachment);
              console.log("result.............................", result);
            }
          } else if (submissionData.hasOwnProperty("file") && !Alert.isAdmin) {
            form.append("attachment", attachment);
          }

          if (Alert.isAdmin || Alert.assignmentTestData.autoevaluate) {
            let s3url;
            if (submissionData.file) {
              if (Alert.assignmentTestData.templateid) {
                const baseURL = `https://gradiouslmsapp.s3.ap-south-1.amazonaws.com/${process.env.REACT_APP_WEBSITE_HOST}`;

                s3url = `${baseURL}/${submissionData.libId}/${
                  !Alert.isAdmin
                    ? getDataFromStorage("learnerid")
                    : Alert.showBreadCrumbsData.learnerId
                }/index.html`;
              } else {
                s3url = `library/submission/${getDataFromStorage(
                  "learnerid"
                )}/${submissionData.libId}/${submissionData.file.name}`;
              }

              form.append("s3url", s3url);
            }
            if (
              submissionData.hasOwnProperty("isUploading") &&
              submissionData.isUploading === false
            ) {
              console.log("\n\n\n\n\n\n removing link condition");

              let oldFileUrl = submissionData?.link;
              form.append("olds3url", oldFileUrl);
            }

            form.append("submit", submissionData.submit);
          }
          if (!Alert.assignmentTestData.autoevaluate) {
            if (
              submissionData.hasOwnProperty("isUploading") &&
              submissionData.isUploading === false
            ) {
              console.log("\n\n\n\n\n\n removing link condition");
              let s3url;

              s3url = submissionData?.link;
              form.append("s3url", s3url);
            }
          }

          if (process.env.REACT_APP_NODE_API.includes("localhost")) {
            url = "node/learner/course/assignment/submit";
          } else {
            url =
              process.env.REACT_APP_CONTAINER_API +
              "node/learner/course/assignment/submit";
          }

          let response = await axios.post(url, form, {
            timeout: 200000,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          Alert.setIsLoaded(false);

          resolve(response);
        } catch (err) {
          console.log("submit assignment err", err);
          Alert.setIsLoaded(false);
          reject(err);
        }
      })();
    });
  };

  return submitAssignment;
};

export default useSubmitAssignment;
